import './Tooltip.css'

const Tooltip = () => {
    return (
        <div id="tooltip" className="tooltip"></div>
    )
}
export default Tooltip;